import styled from 'styled-components'
import FaqItem from './faqItem'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const TncContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 358px;
    padding: 40px 20px;
    background-color: white;
    margin-bottom: 72px;
`

export default function Tnc() {
    const { i18n } = useTranslation('', { keyPrefix: 'helpcentre.enquiry' })
    const lang = i18n.language
    const configs = useSelector((state: any) => state.config.configs)
    const tncFaqItemsList = configs?.helpcentre?.tncList?.map(
        (faqitem: any, index: string) => (
            <FaqItem
                 key={'tnc-' + index}
                question={
                    lang === 'zh' ? faqitem.question_zh : faqitem.question_en
                }
                answer={lang === 'zh' ? faqitem.answer_zh : faqitem.answer_en}
                currentTab={'tnc'}
            />
        )
    )

    return <TncContainer>{tncFaqItemsList}</TncContainer>
}
